import { ENV_PROD } from 'environments/i-prod';
import { IEnvConfig } from 'interfaces/i-env-config';

export const ENV_STAGING: IEnvConfig = {
  ...ENV_PROD,

  // enable console.debug messages for staging without affecting prod
  debug_messages: true,
  region_redirect: true,
  identifier: 'staging',
  self_url: 'https://staging.trajektsports.app',
  server_url: 'https://staging.trajektsports.app/node',
  ws_url: 'https://staging.trajektsports.app/users',
  ws_path: '/socket.io/',

  liveboard_url: 'https://deploy-staging.d1tkhsszyqq0g1.amplifyapp.com',

  integrations: {
    intercom_app_id: ENV_PROD.integrations.intercom_app_id,
    auth0: {
      domain: 'trajektsports.us.auth0.com',
      audience: 'https://trajektsports.us.auth0.com/api/v2/',
      clientId: 'YTw2DYgeCyz2D6Tgb65go8saRVSZEI5k',
    },

    sentry: {
      enabled: true,
      dsn: 'https://d788b74980a6ee68987343d048d92b41@o4509952079429632.ingest.us.sentry.io/4509967840378880',
      environment: 'staging',
      trace_sample_rate: 0,
    },
  },
};
